import { useState, useCallback } from 'react';

const useTrigger = (): [number, () => void] => {
    const [trigger, setTrigger] = useState(0);

    const triggerUpdate = useCallback(() => {
        setTrigger(+new Date());
    }, []);

    return [trigger, triggerUpdate];
};

export default useTrigger;
